export const selectSelectionDrawerOpen = (state) =>
  state.App.selectionDrawerOpen;
export const selectAppTitle = (state) => state.App.appTitle;
export const selectMinInceptionDate = (state) => state.App.minInceptionDate;
export const selectDisableCustomGroupSort = (state) =>
  state.App.disableCustomGroupSort;
export const selectDisableIntersperse = (state) => state.App.disableIntersperse;
export const selectAppDecimal = (state) => state.App.appDecimal;
export const selectBandedRows = (state) => state.App.bandedRows;
export const selectGridVerticalLines = (state) => state.App.gridVerticalLines;
export const selectGridFontSize = (state) => state.App.gridFontSize;
export const selectGridRowHeight = (state) => state.App.gridRowHeight;
export const selectGridHeaderHeight = (state) => state.App.gridHeaderHeight;
export const selectListenScenarioAppTalk = (state) =>
  state.App.listenScenarioAppTalk;
export const selectListenEntityGroupAppTalk = (state) =>
  state.App.listenEntityGroupAppTalk;
export const selectHideGridSideBar = (state) => state.App.hideGridSideBar;
export const selectLoadDataOnLaunch = (state) => state.App.loadDataOnLaunch;
